/* covered.ro: collection hero. Clamps a long description behind a
   "read more" toggle and scrolls the active quick link into view on mobile.
   Without JS the full description shows and the toggle stays hidden. */
if (!customElements.get('cv-collection-hero')) {
  class CvCollectionHero extends HTMLElement {
    connectedCallback() {
      this.desc = this.querySelector('[data-cv-desc]');
      this.more = this.querySelector('[data-cv-more]');
      this.chips = this.querySelector('.cv-collection-hero__chips');

      if (this.desc && this.more) {
        this.onToggle = this.toggle.bind(this);
        this.more.addEventListener('click', this.onToggle);
        this.desc.classList.add('is-clamped');
        this.measure();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.measure());
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.measure());
          this.observer.observe(this.desc);
        }
      }

      this.revealActiveChip();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.more && this.onToggle) this.more.removeEventListener('click', this.onToggle);
    }

    measure() {
      if (this.more.getAttribute('aria-expanded') === 'true') return;
      this.desc.classList.add('is-clamped');
      const overflows = this.desc.scrollHeight > this.desc.clientHeight + 2;
      this.more.hidden = !overflows;
      this.desc.classList.toggle('is-clamped', overflows);
    }

    toggle() {
      const expand = this.more.getAttribute('aria-expanded') !== 'true';
      this.more.setAttribute('aria-expanded', String(expand));
      this.desc.classList.toggle('is-clamped', !expand);
      const label = this.more.querySelector('[data-cv-more-label]');
      if (label) label.textContent = expand ? this.more.dataset.labelLess : this.more.dataset.labelMore;
      if (!expand) {
        const top = this.desc.getBoundingClientRect().top;
        if (top < 0) this.desc.scrollIntoView({ block: 'center' });
      }
    }

    revealActiveChip() {
      if (!this.chips) return;
      const active = this.chips.querySelector('.is-active');
      if (!active || this.chips.scrollWidth <= this.chips.clientWidth) return;
      const item = active.closest('li') || active;
      this.chips.scrollLeft = item.offsetLeft - (this.chips.clientWidth - item.offsetWidth) / 2;
    }
  }

  customElements.define('cv-collection-hero', CvCollectionHero);
}
